import React from 'react';
import { router } from '@forge/bridge';

export const handleArcadeClick = (url: string, event?: React.MouseEvent) => {
    event?.preventDefault();
    void router.open(url);
};
